import { render } from "./AsignacionesLista.vue?vue&type=template&id=0bf2e63b"
import script from "./AsignacionesLista.vue?vue&type=script&lang=js"
export * from "./AsignacionesLista.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__